import React, {useState} from 'react';
import AnchorLink from "react-anchor-link-smooth-scroll";




export const About = () => {
  return (
  <>
  <h1 className="font-weight-bold"> About </h1>
  <br></br>  

     <div className="collection" id="about">
		  
		  <p className="normal">  We're a local t-shirt printing shop ready to accept custom print orders. Feel free to send us your shirt and embroidery designs for a free quote. </p>

        </div>
		</>
  );
};

